import React from "react";
import { MdOutlineAttachment } from "react-icons/md";
export interface MessageBoxProps {
  id: number;
  token: string;
  owner_id: number;
  subject: string;
  body: string;
  from: string;
  to: string;
  is_admin: number;
  user_id: number | null;
  work_order_id: number;
  is_read: number;
  create_time: string;
  update_time: string | null;
  updated_by: string | null;
  email_sent: number;
  process_start: any;
  process_end: any;
  username: string;
  file_attachment: { file_link: string; file_name: string }[] | null;
}


const MessageBox = ({
  file_attachment,
  from,
  body,
  create_time,
  username
}: MessageBoxProps) => {
  return (
    <div
      className={`chat-bx sh-cb ${from ? "reply-bx" : "sender-box"}`}
    >
      <div className="sender-details-bx">
        <p>{from ? username : "Me"}</p>
        <div className="circle-bx">
          <div className="circle"></div>
        </div>
        <div className="chat-date">@ {create_time}</div>
      </div>

      <div className={`message-bx sh-mb ${file_attachment ? 'attachment_division' : ""}`} dangerouslySetInnerHTML={{ __html: body }} />
    
      {file_attachment && (
        <div className="attach-bx">
          <div className="bold-text">
            <MdOutlineAttachment
              size={20}
              style={{ transform: "rotate(-30deg)" }}
            />
            Attachments
          </div>
          
          {
            file_attachment?.map((item, idx)=>{
              return (
          <a key={idx} href={item.file_link} download={`${item?.file_name}`} className="blue-text">
            {item?.file_name}
          </a>
              )
            })
          }
          
        </div>
      )}
    </div>
  );
};

export default MessageBox;
